import { Spin } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import omitDeep from "omit-deep-lodash";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import { fieldRegistryToVariables } from "./catalog";
import View from "./View";

const Canvas = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () =>
    navigate(`${SCREENS.PRIVATE.ADMIN.PROCESSES.DETAIL.path}/${id}`);
  const { data, loading, error, refetch } = useQuery(graphql.queries.PROCESS, {
    variables: { where: { id } },
  });
  // Scoping to this process surfaces its custom fields as canvas variables.
  const { data: registryData } = useQuery(graphql.queries.FIELD_REGISTRY, {
    variables: { process: { id } },
  });
  const variables = useMemo(
    () => fieldRegistryToVariables(registryData?.fieldRegistry),
    [registryData],
  );
  const [updateProcess, { loading: saving }] = useMutation(
    graphql.mutations.UPDATE_PROCESS,
    {
      refetchQueries: [
        { query: graphql.queries.PROCESS, variables: { where: { id } } },
      ],
    },
  );
  const process = useMemo(
    () => (data ? omitDeep(data.process, "__typename") : null),
    [data],
  );
  if (loading || error || !process)
    return (
      <div className="canvas-editor__centered">
        <Spin tip={t("FORM.LOADING", "Loading…")} />
      </div>
    );
  const onSave = (processStatuses) =>
    updateProcess({
      variables: {
        where: { id },
        data: {
          id,
          name: process.name,
          type: process.type,
          theme: process.theme,
          description: process.description,
          processStatuses,
        },
      },
    });
  return (
    <View
      process={process}
      variables={variables}
      cancel={cancel}
      onSave={onSave}
      saving={saving}
      reload={refetch}
    />
  );
};

export default Canvas;
